<template>
    <main>
        <media query="(max-width: 39.9375em)">
            <div class="destinations-building">
                <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide>
                        <div class="destinations-container">
                            <location v-for="location in locations" :location="location" :key="location.name"></location>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="map-container">

                        </div>
                    </swiper-slide>
                </swiper>
                <div class="switch-container">
                    <button :class="{'current-selected': currentIndex === 0}" @click="show(0)">
                        <i class="fa fa-fw fa-list-ul" aria-hidden="true"></i>
                        Regions
                    </button>
                    <button :class="{'current-selected': currentIndex === 1}" @click="show(1)">
                        <i class="fa fa-fw fa-map" aria-hidden="true"></i>
                        Map
                    </button>
                </div>
            </div>
        </media>
        <media query="(min-width: 40em) and (max-width: 63.9375em)">
            <div class="destinations-building">
                <div class="destinations-container">
                    <location v-for="location in locations" :location="location" :key="location.name"></location>
                </div>
                <div class="map-container">

                </div>
            </div>
        </media>
        <media query="(min-width: 64em)">
            <div class="destinations-building">
                <div class="destinations-container">
                    <location v-for="location in firstHalf" :location="location" :key="location.name"></location>
                </div>
                <div class="map-container">

                </div>
                <div class="destinations-container destinations-container--second">
                    <location v-for="location in secondHalf" :location="location" :key="location.name"></location>
                </div>
            </div>
        </media>
    </main>
</template>

<script>
	import {swiper, swiperSlide} from 'vue-awesome-swiper'
	import Media from 'vue-media';
	import Location from './location.vue';
	export default {
		components: {
			Media,
			Location,
			swiper,
            swiperSlide
		},
		mounted () {
			console.log(this.$refs);
		},
		data () {
			return {
				currentIndex: 0,
				defaultMap: "Bethlehem",
				swiperOption: {
					autoHeight: true,
					onSetTransition: (swiper) => {
						this.currentIndex = swiper.activeIndex
					}
				},
				locations: [
					{
						name: "BETHLEHEM",
						url: "/wp-content/uploads/2017/01/Bethlehemcity-800x600.jpg",
                        link: "/destinations/bethlehem/"
					},
					{
						name: "GAZA",
						url: "/wp-content/uploads/2016/06/iStock-458276129-800x600.jpg",
                        link: "/destinations/gaza/"
					},
					{
						name: "HEBRON",
						url: "/wp-content/uploads/2016/06/160146438-2-800x600.jpg",
                        link: "/destinations/hebron/"
					},
					{
						name: "JENIN",
						url: "/wp-content/uploads/2016/06/Jenin-Old-City-800x600.jpg",
                        link: "/destinations/jenin/"
					},
					{
						name: "JERICHO",
						url: "/wp-content/uploads/2016/06/Jericho-Hishams-Palace-1-800x600.jpg",
                        link: "/destinations/jericho/"
					},
					{
						name: "JERUSALEM",
						url: "/wp-content/uploads/2016/06/Jerusalem100-800x600.jpg",
                        link: "/destinations/jerusalem/"
					},
					{
						name: "NABLUS",
						url: "/wp-content/uploads/2016/06/Nablus-Mt-Jarzim-1-800x600.jpg",
                        link: "/destinations/nablus/"
					},
					{
						name: "QALQILYA",
						url: "/wp-content/uploads/2016/06/Jinsafut-1-800x600.jpg",
                        link: "/destinations/qalqilya/"
					},
					{
						name: "RAMALLAH & AL BIREH",
						url: "/wp-content/uploads/2016/06/458326105-800x600.jpg",
                        link: "/destinations/ramallah-al-bireh/"
					},
					{
						name: "SALFIT",
						url: "/wp-content/uploads/2016/06/Salfit-1-300x154.jpg",
                        link: "/destinations/salfit/"
					},
					{
						name: "TUBAS",
						url: "/wp-content/uploads/2016/06/Tubas-300x159.jpg",
                        link: "/destinations/tubas/"
					},
					{
						name: "TULKAREM",
						url: "/wp-content/uploads/2016/06/Tulkarem-City-1-800x600.jpg",
                        link: "/destinations/tulkarem/"
					}
				]
			};
		},
        methods: {
		    show (slide) {
		    	this.getSwiper().slideTo(slide);
            },
            getSwiper () {
				return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : {}
            },
        },
		computed: {
			mapSrc () {
				let key = 'AIzaSyAzQF88IKk8CENCtcG3-ysGMDva3krpaeo';
				return `https://www.google.com/maps/embed/v1/place?key=${key}&q=${this.defaultMap}&zoom=13
  &maptype=satellite`
            },
			firstHalf () {
				return this.locations.slice(0, 6)
			},
			secondHalf () {
				return this.locations.slice(6)
			}
		}
	}
</script>

<style lang="scss" scoped>
    @import "~foundation-sites/scss/foundation";

    $mobile-header-height: 64px;
    $margin: 5px;
    $vp-height: calc(100vh - #{$mobile-header-height});
    //mobile first approach
    main {
        width: 100%;
        height: $vp-height;
        background: white;
        overflow: auto;
    }

    .destinations-building {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .destinations-container,
        .map-container {
            flex: 100% 0;
        }
        @include breakpoint(medium) {
            .destinations-container,
            .map-container {
                flex: calc(100% / 2) 0;
            }
        }
        @include breakpoint(large) {
            .destinations-container,
            .map-container {
                flex: calc(100% / 3) 0;
            }
        }
    }

    .destinations-container {
        width: 100vw;
        display: flex;
        flex-wrap: wrap;
        height: $vp-height;
        overflow: auto;
        @include breakpoint(medium) {
            overflow: auto;
        }
    }

    .switch-container {
        display: flex;
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: white;
        box-shadow: 0 0 10px 1px rgba(0, 0, 0, .4);
        height: 50px;
        z-index: 1;
        button {
            &.current-selected {
                color: #567e3f;
            }
            flex: 50% 0;
            width: 50%;
            border: none;
            background: none;
            height: 100%;
            font-size: 1.1rem;
        }
    }

    .map-container  {
        width: 100%;
        margin-top: .5rem;
        box-shadow: 0 0 3px 1px rgba(0,0,0,.3);
        height: calc(#{$vp-height} - 1rem);
        padding: 0 .5rem;
        padding-top: .5rem;
        background-image: url(https://www.welcometopalestine.com/wp-content/uploads/2017/04/map-fb.jpg);
        background-size: 130%;
        background-position: center 30%;
    }

    #chartdiv {
        width: 100%;
        height: $vp-height;
    }
</style>


// WEBPACK FOOTER //
// destinations.vue?9bed2818